import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'

// 目次タブ（tabs）のページ内スクロールとタブハイライト。PC/SP共用のため common/ に配置する
// （site_desktop.js / site_mobile.js の require.context が common/component_controller を登録する。
// 識別子の前提は common/component.rb の stimulus_controller コメント参照）。
//
// - scrollTo: ページ内アンカータブ（href="#..."）のクリックで対象セクションへスムーズスクロール
// - ハイライト: アンカータブの対象セクションがビューポートに入ったときタブをアクティブ表示。
//   外部リンクタブ（href が "#" 始まりでない）は遷移先で管理するため対象外
//
// 72px はstickyタブ実高さ約49px＋視認マージンと連動した値。変更時はこのファイル内の
// offset / rootMargin と、ページCSSの scroll-margin-top 全箇所
// （review_variant の #rv-top / #rv-basic / .rv-qa-featured）を同時に更新すること。
//
// 状態クラスはビュー側が data-*-class（Classes API）で渡し、JSはリテラルのクラス名・セレクタを持たない
// （アンカーのid参照はスコープ化の影響を受けないため可。#13886 の設計ルール参照）
const STICKY_OFFSET = 72

export default class extends Controller {
  static targets = ['tab']
  static classes = ['active']

  initialize () {
    this.scroll = new SmoothScroll(null, {
      offset: STICKY_OFFSET,
      speed: 600,
      speedAsDuration: true,
      easing: 'linear',
      updateURL: false,
      popstate: false,
    })
    this.observers = []
  }

  connect () {
    this.setupHighlight()
  }

  disconnect () {
    this.observers.forEach((observer) => observer.disconnect())
    this.observers = []
  }

  // アンカータブクリック → 対象セクションへスムーズスクロール。
  // アンカーが無いページ（対象セクションがデータ欠落で非描画）ではpreventDefaultせず、
  // ブラウザ既定のアンカー挙動に委ねる
  // （先にpreventDefaultすると無反応ボタンになり、要素欠落が握りつぶされるため）
  scrollTo (event) {
    const anchor = this.anchorFor(event.currentTarget)
    if (!anchor) { return }
    event.preventDefault()
    this.scroll.animateScroll(anchor)
  }

  // タブのhref（"#section-id"）から対象セクション要素を引く。外部リンクタブはnull
  anchorFor (tab) {
    const href = tab.getAttribute('href') || ''
    if (!href.startsWith('#')) { return null }
    return document.getElementById(href.slice(1))
  }

  // アンカータブの対象セクションがビューポートに入ったとき、そのタブをハイライトする
  setupHighlight () {
    if (!window.IntersectionObserver) { return }
    this.tabTargets.forEach((tab) => {
      const section = this.anchorFor(tab)
      if (!section) { return }
      // disconnect() で解除できるよう保持する
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          tab.classList.toggle(this.activeClass, entry.isIntersecting)
        })
      }, { rootMargin: `-${STICKY_OFFSET}px 0px 0px 0px`, threshold: 0 })
      observer.observe(section)
      this.observers.push(observer)
    })
  }
}
